.alignment {
    display: flex;
    justify-content: center;
}

.heading {
    font-weight: 400;
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
    width: auto;
}

.h2 {
    font-size: 1.875rem;
}

.h3 {
    font-size: 1.5rem;
}

.h4 {
    font-size: 1rem;
}

.rope {
    padding: 26px 0;

    & h2,
    & h3,
    & h4 {
        align-items: center;
        display: flex;
        gap: 0.5rem;
        width: 100%;

        &::before,
        &::after {
            background-image: url("../../../static/img/rope.svg");
            background-position-x: 0;
            background-position-y: 50%;
            background-repeat: repeat-x;
            background-size: 31px 40px;
            content: "";
            display: block;
            flex: 1;
            height: 31px;
        }
    }
}
